import React from 'react'
import { Row, Col, Card, Space, Statistic, Progress, Typography } from 'antd'
import { MedicineBoxOutlined } from '@ant-design/icons'

const { Text } = Typography

const BedManagementTab = ({ wardSummary }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <Card
          title={
            <Space>
              <MedicineBoxOutlined /> Bed Availability by Ward
            </Space>
          }
        >
          <Row gutter={[16, 16]}>
            {wardSummary.map((ward) => (
              <Col xs={24} sm={12} md={8} key={ward.ward}>
                <Card size='small' title={ward.ward}>
                  <Statistic
                    title='Occupancy'
                    value={Math.round((ward.occupied / ward.beds) * 100)}
                    suffix='%'
                    valueStyle={{
                      color:
                        ward.occupied / ward.beds > 0.9
                          ? '#cf1322'
                          : ward.occupied / ward.beds > 0.75
                          ? '#faad14'
                          : '#3f8600'
                    }}
                  />
                  <div style={{ marginTop: '10px' }}>
                    <Progress
                      percent={Math.round((ward.occupied / ward.beds) * 100)}
                      strokeColor={
                        ward.occupied / ward.beds > 0.9
                          ? '#cf1322'
                          : ward.occupied / ward.beds > 0.75
                          ? '#faad14'
                          : '#3f8600'
                      }
                      size='small'
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                      <Text type='secondary'>Occupied: {ward.occupied}</Text>
                      <Text type='secondary'>Available: {ward.available}</Text>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default BedManagementTab
